import React from 'react';

const SelectWithLabelOption = ({ label = 'I want to learn', option = 'Spanish' }) => {
  return (
    <div className="flex !h-full items-center justify-between rounded-lg border border-gray-300 bg-white px-4 py-3 ">
      <div className="flex flex-col gap-1">
        <p className="fredoka text-sm -tracking-[0.28px] text-[#012E33]">{label}</p>
        <p className="fredoka text-base font-medium capitalize -tracking-[0.16px] text-[#012E33]">
          {option}
        </p>
      </div>
      <img src="/images/icons/chevron-down-outline.svg" alt="" />
    </div>
  );
};

export default SelectWithLabelOption;
